import { Carrier } from "./carrier.model";

export class CarrierMapper {
  public static map(carrierData: any): Carrier {
    if (!carrierData) {
      return null;
    }

    return new Carrier(
      carrierData.id,
      carrierData.name,
      carrierData.kind,
      carrierData.code ?? null,
    );
  }
}
